import fetcher from "@/core/lib/fetcher";
import {
	PaymentConnectionFormValues,
	DynamicFormValues,
	ConnectedProvider,
	Provider,
	PaymentGateway,
} from "./payment.types";
import { queryOptions } from "@tanstack/react-query";
import { APIResponse } from "@/core/types/utils";

// ── PCI Booking external API ──────────────────────────────────────────────────
export const getPaymentGateways = () =>
	queryOptions({
		queryKey: ["paymentGateways"],
		queryFn: () =>
			fetcher
				.url(`${import.meta.env.VITE_PCI_BASE_URL}/api/paymentGateway`)
				.get()
				.json<PaymentGateway[]>(),
	});

export const getGatewayFields = (providerName: string) =>
	queryOptions({
		enabled: !!providerName,
		queryKey: ["gatewayFields", providerName],
		queryFn: () =>
			fetcher
				.url(
					`${import.meta.env.VITE_PCI_BASE_URL}/api/credentials/paymentGateway/${providerName}`,
				)
				.get()
				.json<string[]>(),
	});

// ── Internal API ──────────────────────────────────────────────────────────────

export const connectProvider = (
	providerData: PaymentConnectionFormValues | DynamicFormValues,
	siteId: string,
	token: string,
) =>
	fetcher
		.auth(`Bearer ${token}`)
		.url(import.meta.env.VITE_API_BOOKING + `resource/${siteId}/payment-method`)
		.post(providerData)
		.json();

export const getConnectedProviders = (siteId: string, token: string) =>
	queryOptions({
		queryKey: ["connectedProviders", siteId, token],
		queryFn: async () => {
			try {
				return await fetcher
					.auth(`Bearer ${token}`)
					.url(
						import.meta.env.VITE_API_BOOKING +
							`resource/${siteId}/payment-methods`,
					)
					.get()
					.json<APIResponse<ConnectedProvider[]>>();
			} catch {
				return { data: [], message: "", success: true } as APIResponse<
					ConnectedProvider[]
				>;
			}
		},
	});
export const getProviders = () =>
	queryOptions({
		queryKey: ["providers"],
		queryFn: () =>
			fetcher

				.url(import.meta.env.VITE_API_BOOKING + `payment-providers`)
				.get()
				.json<APIResponse<Provider[]>>(),
	});

export const logoutProvider = (siteId: string, id: string, token: string) =>
	fetcher
		.auth(`Bearer ${token}`)
		.url(
			import.meta.env.VITE_API_BOOKING +
				`resource/${siteId}/payment-method/${id}`,
		)
		.delete()
		.json<APIResponse<string>>();
